module.exports = __webpack_public_path__ + "img/eu.8224e42.svg";